import React from "react";
import styles from "./SchoolGrade.module.scss";
import Image from "next/image";

const SchoolGrade = ({ data }) => {
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <>
    {data && (
    <div className={`section_pading ${styles.school_grade}`}>
      <div className="container">
        <div className={`row ${styles.items_wp}`}>
          {data?.map((item, index) => (
            <div className="col-lg-3" key={index}>
              <div className={styles.cardwp}>
                <div className={styles.bgimg}>
                  <Image
                    height={376}
                    width={300}
                    src={item?.image?.results?.[0]?.fileUrl}
                    alt={`bg-${index}`} // Ensure alt attribute is unique
                    data-testid={`bg-item-${index}`} // Correct data-testid attribute
                    className={styles.bghs}
                  />
                </div>
                <div className={`school-grade-card ${styles.cardwpcont}`}>
                  <Image
                    src={item?.icon?.results?.[0]?.fileUrl}
                    alt={`icon-${index}`} // Ensure alt attribute is unique
                    data-testid={`icon-item-${index}`} // Correct data-testid attribute
                    width={51}
                    height={42}
                    className={`${styles.card_img_new} mb-3`}
                  />
                  <h3>{item?.subtitle}</h3>
                  <p className="mb-0">{item?.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
     )}
    </>
  );
};

export default SchoolGrade;
